export const routes = (prefix = `radiology`) => [
    {
        path: `/${prefix}/reporting-queue`,
        name: `${prefix}.reporting-queue.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.reporting-queue.index`,
                PageDescription: "Radiology: Reporting Patient Queue",
            },
        },
    },
];
